import React, { Component } from 'react';
import homedata from '../../data/homedata.json';


class Feature extends Component {
  render() {
   let publicUrl = process.env.PUBLIC_URL
   let imgattr = 'image'

   // Use props if provided, otherwise fall back to homedata
   const data = this.props.data || homedata.features;
   const customClass = this.props.className || '';
   const hideImages = this.props.hideImages || false;
   const fullWidth = this.props.fullWidth || false;

    return (
      <section id="feature" className={`p-80px-tb position-relative ${customClass}`}>
         <div className="filled-circle"></div>
         <div className="container">
            <div className="row">
               <div className="col-sm-8 offset-sm-2">
                  <div className="section-title text-center m-50px-b">
                     <h2>{data.sectiontitle || data.title}</h2>
                     {data.subtitle && <p className="lead text-muted">{data.subtitle}</p>}
                  </div>
               </div>
            </div>
            <div className="row align-items-center">
               <div className={hideImages || fullWidth ? 'col-12' : 'col-lg-6 col-md-12 md-p-50px-b'}>
                  <div className="row">
                     {(data.featurescontent || data.cards || []).map( ( feature, i ) =>
                        <div key={i} className={fullWidth ? 'col-lg-4 col-md-6 m-30px-b' : 'col-sm-6'}>
                           <div className={fullWidth ? 'card h-100 shadow-sm hover-shadow transition' : 'single-feature'}>
                              {fullWidth ? (
                                <div className="card-body p-40px">
                                  <div className="feature-icon m-25px-b">
                                    <i className={`${feature.icon} icofont-3x text-primary`}></i>
                                  </div>
                                  <h4 className="font-weight-bold m-20px-b">{feature.title}</h4>
                                  <p className="text-muted">{feature.content}</p>
                                </div>
                              ) : (
                                <>
                                  <i className={feature.icon}></i>
                                  <h4>{feature.title}</h4>
                                  <p>{feature.content}</p>
                                </>
                              )}
                           </div>
                        </div>
                     )}
                  </div>
               </div>
               {!hideImages && !fullWidth && (
                  <div className="col-lg-6 col-md-12">
                     <div className="position-relative featured-mockup">
                        <div className="bordered-box"></div>
                        <img className="phone-1" src={publicUrl+(data.imgurl1 || "/assets/img/iphone-1.png")} alt={imgattr}/>
                        <img className="phone-2" src={publicUrl+(data.imgurl2 || "/assets/img/iphone-2.png")} alt={imgattr}/>
                     </div>
                  </div>
               )}
            </div>
         </div>
      </section>

    );
  }
}

export default Feature;
